// InvitationMessageSection

import Container from "../../../components/ui/Container";

export default function InvitationMessageSection() {
  return (
    <section className="event-noise bg-twilight-indigo-950 px-0 py-16 text-white md:py-24">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="mx-auto mb-16 h-16 w-px bg-amber-flame-500/70" />

          <p className="mx-auto font-serif text-xl italic leading-relaxed text-slate-100 md:max-w-[560px] md:text-2xl">
            You are cordially invited to the Inauguration Ceremony &amp;
            Reconciliation Ball of the University of Liberia Faculty
            Association,
            <br />
            <span className="text-white">(ULFA).</span>
          </p>

          <p className="mx-auto mt-12 max-w-3xl font-serif text-xl italic leading-relaxed text-slate-100 md:max-w-[560px] md:text-2xl">
            Join us as we install and honor our new leaders in unity,
            tranquility, and progress!
          </p>

          <div className="mx-auto mt-16 h-16 w-px bg-amber-flame-500/70" />
        </div>
      </Container>
    </section>
  );
}